@if (languageChange$ | async; as _lang) {
  <ng-container *transloco="let t">
    <div class="header align-items-stretch">
      <!--begin::Container-->
      <div class="container-xxl d-flex align-items-stretch justify-content-between">
        <!--begin::Brand-->
        <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0 w-lg-225px me-5">
          <!--begin::Aside mobile toggle-->
          <div (click)="openMobileMenu()" class="btn btn-icon btn-active-icon-primary ms-n2 me-2 d-flex d-lg-none">
            <!--begin::Svg Icon-->
            <span [inlineSVG]="'assets/media/icons/duotune/abstract/abs015.svg'" class="svg-icon svg-icon-1"></span>
            <!--end::Svg Icon-->
          </div>
          <!--end::Aside mobile toggle-->
          <!-- begin::Logo Container -->
          <div class="position-relative">
            <!-- Logo -->
            <a title="Logo" [routerLink]="['/', _lang]">
              <img [title]="env.orgId + ' logo'" [alt]="env.orgId" [src]="env.logo" class="d-none d-lg-inline h-{{ env.logoSize }}px theme-light-show" />
              <img [title]="env.orgId + ' logo'" [alt]="env.orgId" [src]="env.logoDark" class="d-none d-lg-inline h-{{ env.logoSize }}px theme-dark-show" />
              <!-- Mobile View -->
              <img [title]="env.orgId + ' logo'" [alt]="env.orgId" [src]="env.logo" class="d-lg-none h-25px theme-light-show" />
              <img [title]="env.orgId + ' logo'" [alt]="env.orgId" [src]="env.logoDark" class="d-lg-none h-25px theme-dark-show" />
              <!-- Christmas -->
              @if (env.orgId === "bildelsbasen" && env.isChristmas) {
                <!-- Christmas Tree -->
                <span [inlineSVG]="'assets/media/svg/general/tree.svg'" class="svg-icon svg-icon-2x position-absolute"></span>
                <!-- Lighting Decoration -->
                <span [inlineSVG]="'assets/media/svg/general/lights.svg'" class="svg-icon svg-icon-4x position-absolute lights"></span>
              }
            </a>
            <!-- end::Logo -->
          </div>
          <!-- end::Logo Container -->
        </div>
        <!--end::Brand-->
        <!--begin::Wrapper-->
        <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
          <!--begin::Navbar-->
          <div class="d-flex align-items-stretch">
            <!--begin::Menu wrapper-->
            <div class="header-menu flex-column flex-lg-row">
              <!--begin::Menu-->
              <div class="menu menu-rounded menu-column menu-lg-row menu-root-here-bg-desktop menu-active-bg menu-state-primary menu-title-gray-800 menu-arrow-gray-400 align-items-stretch flex-grow-1 my-5 my-lg-0 px-2 px-lg-0 fw-semibold fs-6">
                <!--begin:Menu item-->
                <div class="menu-item me-0 me-lg-2">
                  <!--begin:Menu link-->
                  <a [title]="t('label_home')" [routerLink]="['/', _lang]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" transloco="label_home" class="menu-link py-3"> </a>
                  <!--end:Menu link-->
                </div>
                <!--end:Menu item-->
                <!--begin:Menu item-->
                <div class="menu-item me-0 me-lg-2">
                  <!--begin:Menu link-->
                  <a [title]="t('label_affiliated_companies')" [routerLink]="['/', _lang, 'affiliated-companies']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" transloco="label_affiliated_companies" class="menu-link py-3">
                  </a>
                  <!--end:Menu link-->
                </div>
                <!--end:Menu item-->
                <!--begin:Menu item-->
                <div class="menu-item me-0 me-lg-2">
                  <!--begin:Menu link-->
                  <a [title]="t('label_saved_parts')" [routerLink]="['/', _lang, 'saved-parts']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="menu-link py-3 position-relative">
                    <span transloco="label_saved_parts"></span>
                    @defer (on immediate) {
                      @if (count() > 0) {
                        <span class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-primary badge-sm">
                          {{ count() }}
                        </span>
                      }
                    }
                  </a>
                  <!--end:Menu link-->
                </div>
                <!--end:Menu item-->
              </div>
              <!--end::Menu-->
            </div>
            <!--end::Menu wrapper-->
          </div>
          <!--end::Navbar-->
          <!--begin::Toolbar wrapper-->
          <div class="d-flex align-items-stretch flex-shrink-0">
            <!--begin:: Quick Saved Searches -->
            <app-quick-saved-searches-counter class="d-flex align-items-stretch ms-1 ms-lg-2"></app-quick-saved-searches-counter>
            <!-- end:: Quick Saved Searches -->

            <!--begin:: Quick Search-->
            <app-quick-search class="d-none d-md-flex align-items-stretch ms-1 ms-lg-2"></app-quick-search>
            <!--end:: Quick Search-->

            <!--begin:: Quick Cart-->
            <app-quick-cart-counter class="d-flex align-items-stretch ms-1 ms-lg-2"></app-quick-cart-counter>
            <!--end::Quick Cart-->

            <!--begin::Theme Mode-->
            <app-theme-mode-switch class="d-none d-md-flex align-items-stretch ms-1 ms-lg-2"></app-theme-mode-switch>
            <!--end::Theme Mode-->

            <!--begin::Visitor Settings-->
            <app-visitor-setting class="d-flex align-items-stretch ms-1 ms-lg-2"></app-visitor-setting>
            <!--end::Visitor Settings-->

            <!-- begin:: User info / Login -->
            <app-user-info class="d-flex align-items-center ms-lg-5"></app-user-info>
            <!-- end:: User info / Login -->
          </div>
          <!--end::Toolbar wrapper-->
        </div>
        <!--end::Wrapper-->
      </div>
      <!--end::Container-->
    </div>
    <!-- begin:: Seller Own Stock -->
    <app-seller-own-stock-banner></app-seller-own-stock-banner>
    <!-- end:: Seller Own Stock -->
  </ng-container>
}
